import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css'

const NotificationHandler = (message, type) => {

    toast.configure();
    return (
        type === 'success'
            ? toast.success(<div className="hk-toast"><i className="icon-check-circle"></i> {message}</div>, { position: toast.POSITION.TOP_CENTER })
            : type === 'info'
                ? toast.info(message, { position: toast.POSITION.TOP_CENTER })
                : type === 'warning'
                    ? toast.warn(<div className="hk-toast"><i className="icon-warning1"></i> {message}</div>, { position: toast.POSITION.TOP_CENTER })
                    : type === 'dark'
                        ? toast.dark(message, { position: toast.POSITION.TOP_CENTER })
                        : type === 'error'
                            ? toast.error(<div className="hk-toast"><i className="icon-delete"></i> {message}</div>, { position: toast.POSITION.TOP_CENTER })
                            : type === 'basic'
                                ? toast(message, { position: toast.POSITION.TOP_CENTER })
                                : null

    )
}

export default NotificationHandler